import { isEnumControl, isOneOfControl, isOneOfEnumControl, or, rankWith } from "@jsonforms/core";

export default rankWith(6, or(isEnumControl, isOneOfControl, isOneOfEnumControl));
